import { VStack } from "@chakra-ui/react"
import React from "react"
import { AssignPhoneDeviceForm } from "../../forms"
import { ExtendedUserFragment } from "../../graphql"

export type AssignPhoneDeviceProps = {
	user: ExtendedUserFragment
}

export const AssignPhoneDevice: React.FC<AssignPhoneDeviceProps> = ({ user }) => {
	return (
		<VStack w="full" spacing={6} maxW="sm">
			<AssignPhoneDeviceForm user={user} />
		</VStack>
	)
}
